import { get } from 'lodash';
import { APIS } from '../../../../../lib/constants/apis';
import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
import { addIndexesToPath } from '../../../../../utils/helper';
const P = Schema.attributes;

type Dependencies = {
	files: any[];
	relations: any[];
};
function FoerderAntragDependencies(application: any) {
	let dependencies: Dependencies = {
		files: [],
		relations: [],
	};
	const verbundpartner = get(application, P.Verbundpartner.path, []);
	for (let i = 0; i < verbundpartner.length; i++) {
		dependencies.relations.push({
			field: addIndexesToPath(P.Verbundpartner.schema.attributes.Verbundpartner.path, [`${i}`], ['Verbundpartner']),
			api: APIS.Organisation,
		});
	}

	const assoziertepartner = get(application, P.Assoziierte_Partner.path, []);
	for (let i = 0; i < assoziertepartner.length; i++) {
		const eachPartner = assoziertepartner[i];
		const id = get(eachPartner, 'Partner.id', '');
		// Normalerweise werden Asso. Partner nicht extra als Organisation angelegt.
		// Aber falls doch, soll die Relation trotzdem angelegt werden, damit die Verknüpfung in der Übersicht angezeigt werden können und zu i-taros übertragen werden kann.
		if (Number(id) > 0) {
			dependencies.relations.push({
				field: addIndexesToPath(P.Assoziierte_Partner.schema.attributes.Partner.path, [`${i}`], ['Assoziierte_Partner']),
				api: APIS.Organisation,
			});
		}
	}

	dependencies.relations.push({ field: P.Foerderantrag_Kostenpositions.path, api: APIS.Kostenposition });

	return dependencies;
}
export { FoerderAntragDependencies };
